// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"3867c6cc","496":"6cf33b22","498":"aea110cb","657":"044c07f2","787":"235e9fed"}[chunkId] + ".chunk.js";
};